<template>
  <div id="product_detail" class="h-full pb-10 overflow-y-auto" v-if="isLoaded">
    <div class="mb-3 h-1/2">
      <img v-if="product.thumbnail" class="classen__rounded" :src="product.thumbnail">
      <img v-else src="../../../assets/media/NoImage.png" alt="no image">
    </div>
    <div class="grid grid-cols-1 gap-5 xl:grid-cols-2">
      <div class="properties">
        <c-list-item v-if="productData.name" :data="productData.name"
                     :translation-key="'articleName'"/>
        <c-list-item v-if="productData.id" :data="productData.id"
                     :translation-key="'articleNumber'"/>
        <c-list-item v-if="productData.rangeName" :data="productData.rangeName"
                     :translation-key="'rangeName'"/>
        <c-list-item v-if="productData.categoryName" :data="productData.categoryName"
                     :translation-key="'category'"/>
        <c-list-item v-if="productData.collectionName" :data="productData.collectionName"
                     :translation-key="'collection'"/>
        <c-list-item v-if="productData.tagName" :data="productData.tagName"
                     :translation-key="'productGroup'"/>
        <c-list-item v-if="dimensions" :data="dimensions" :translation-key="'dimensions'"/>
        <c-list-item v-if="getProductFeature('structure')" :data="getProductFeature('structure')"
                     :translation-key="'structure'"/>
        <c-list-item v-if="getProductFeature('lockingSystem')"
                     :data="getProductFeature('lockingSystem')" :translation-key="'lockingSystem'"/>
        <c-list-item v-if="getProductFeature('bevel')" :data="getProductFeature('bevel')"
                     :translation-key="'bevel'"/>
        <c-list-item v-if="getProductFeature('bevelColor')" :data="getProductFeature('bevelColor')"
                     :translation-key="'bevelColor'"/>
        <c-list-item v-if="getProductFeature('acClassification')"
                     :data="getProductFeature('acClassification')"
                     :translation-key="'acClassification'"/>
        <c-list-item v-if="getProductFeature('wearclass') && false" :data="getProductFeature('wearclass')"
                     :translation-key="'wearClass'"/>
      </div>

      <div class="properties">
        <div v-if="decorData && decorData.name"
             class="listItemElement text-left border-b-2 border-classen__secondary">
          <div>
            <label>{{ getTranslation('decor') }}</label>
          </div>
          <div>
            <label class="block font-bold" :class="{'underline cursor-pointer': showLinks}"
                   @click="redirectToDecor(decorData)">{{ decorData.number }} {{ decorData.name }}</label>
          </div>
        </div>
        <c-list-item v-if="decorData && decorData.plankColor" :data="decorData.plankColor"
                     :translation-key="'plankColor'"/>
        <c-list-item v-if="decorData && decorData.material" :data="decorData.material"
                     :translation-key="'material'"/>
        <c-list-item v-if="getProductFeature('planksPerBox')"
                     :data="getProductFeature('planksPerBox')" :translation-key="'planksPerBox'"/>
        <c-list-item v-if="getProductFeature('sqmPerUnit')" :data="getProductFeature('sqmPerUnit')"
                     :translation-key="'areaPerBox'"/>
        <c-list-item v-if="getProductFeature('weightPerUnit')"
                     :data="roundWeights(getProductFeature('weightPerUnit'))" :translation-key="'weightPerBox'"/>
        <c-list-item v-if="getProductFeature('boxesPerPallet')"
                     :data="getProductFeature('boxesPerPallet')"
                     :translation-key="'boxesPerPallet'"/>
        <c-list-item v-if="getProductFeature('sqmPerPallet')"
                     :data="getProductFeature('sqmPerPallet')" :translation-key="'areaPerPallet'"/>
        <c-list-item v-if="getProductFeature('weightPerPallet')"
                     :data="roundWeights(getProductFeature('weightPerPallet'))"
                     :translation-key="'weightPerPallet'"/>
        <c-list-item v-if="getProductFeature('grossWeightOfSqm')"
                     :data="roundWeights(getProductFeature('grossWeightOfSqm'))"
                     :translation-key="'grossWeightOfSqm'"/>
        <c-list-item v-if="getProductFeature('eanCode')" :data="getProductFeature('eanCode')"
                     :translation-key="'eanCode'"/>
        <c-list-item v-if="getProductFeature('certification')"
                     :data="getProductFeature('certification')" :translation-key="'certification'"/>
        <c-list-item v-if="getProductFeature('environmentalLabel')"
                     :data="getProductFeature('environmentalLabel')"
                     :translation-key="'environmentalLabel'"/>
        <c-list-item v-if="getProductFeature('guaranty')" :data="getProductFeature('guaranty')"
                     :translation-key="'guaranty'"/>

        <div v-if="productData.box && productData.box.name"
             class="listItemElement text-left border-b-2 border-classen__secondary">
          <div>
            <label>{{ getTranslation('box') }}</label>
          </div>
          <div>
            <label class="block font-bold" :class="{'underline cursor-pointer': showLinks}"
                   @click="redirectToPackage(productData.box)">{{ productData.box.name }}</label>
          </div>
        </div>
        <div v-if="productData.inlay && productData.inlay.name"
             class="listItemElement text-left border-b-2 border-classen__secondary">
          <div>
            <label>{{ getTranslation('inlay') }}</label>
          </div>
          <div v-if="productData.inlay.name">
            <label class="block font-bold" :class="{'underline cursor-pointer': showLinks}"
                   @click="redirectToPackage(productData.inlay)">{{ productData.inlay.name }}
            </label>
          </div>
        </div>

        <c-list-item v-if="getProductFeature('phaseOut')" :data="getProductFeature('phaseOut')"
                     :translation-key="'phaseOut'"/>
      </div>
    </div>
  </div>
</template>
<script>
import ListItem from "../ListItem";
import EventBus from "../../../services/EventBus";
import getTranslation from "../../../mixins/getTranslation";

export default {
  name: 'ProductDetailForm',

  mixins: [getTranslation],

  props: {
    product: {},
    showLinks: {required: false, default: true}
  },

  components: {
    'c-list-item': ListItem
  },

  data() {
    return {
      productData: null,
      decorData: null,
      dimensions: null,
      isLoaded: false,
      box: null,
      inlay: null,
    }
  },

  created() {
    const sharedSelectionId = this.$route.params.id;
    if (sharedSelectionId) {
      this.getProductsAndDecorsForSharedSelection(sharedSelectionId);
      return;
    }

    this.getProductsAndDecors();
  },

  methods: {
    async getProductsAndDecors() {
      this.productData = this.product;
      this.dimensions = this.getDimensions();
      this.getDecorData();
      this.isLoaded = true;
    },

    async getDecorData() {
      let decorName = this.productData.decorName
      decorName = decorName.replace(/\s/g, '+');
      const decor = await this.$dashboardStore.dispatch('getDecor', decorName);

      this.decorData = decor.data;
    },

    getProductsAndDecorsForSharedSelection(sharedSelectionId) {
      this.$dashboardStore.dispatch('getProductForSharedSelection', {
        productId: this.product.id,
        selectionId: sharedSelectionId
      }).then((res) => {
        this.productData = res.data;
        this.dimensions = this.getDimensions();

        if (!this.productData.decorNumber) {
          this.isLoaded = true;
          return;
        }

        this.$dashboardStore.dispatch('getDecorForSharedSelection', {
          decorId: this.productData.decorNumber,
          selectionId: sharedSelectionId
        }).then((decor) => {
          this.decorData = decor.data;
          this.isLoaded = true
        });
      });
    },

    getDimensions() {
      const length = this.getProductFeature('length');
      const width = this.getProductFeature('width');
      const height = this.getProductFeature('height');

      if (!(length && width && height)) {
        return null;
      }

      return `${length} x ${width} x ${height}`
    },

    getProductFeature(key) {
      if (!this.productData || !this.productData.features) {
        return null;
      }

      let property = this.productData.features.find((feature) => {
        return feature.key === key
      });

      if (!property) {
        return null;
      }

      if (property.value === null) {
        return '-';
      }

      return property.value;
    },

    redirectToPackage(packaging) {
      if (!this.showLinks) {
        return
      }

      EventBus.fire('set-active_packaging', packaging)
    },

    redirectToDecor(decor) {
      if (!this.showLinks) {
        return
      }

      let d2 = decor
      d2.id = decor.number
      EventBus.fire('set-active_decor', d2)
    },

      roundWeights(weight) {
        weight = weight.toString();
        return weight.slice(0, (weight.indexOf(".")) + 4);
      }
  }
}
</script>
<style scoped>

img {
  width: 65%;
  max-height: 100%;
  object-fit: cover;
}

.listItemElement {
  display: grid;
  min-height: 35px;
  grid-template-columns: 40% 60%;
}

.thumbnail {
  height: 500px;
  object-fit: cover;
}
</style>
